import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Benefits as Benefits$1 } from "@perxis-auto/ui-kit/lib/components/Benefits";
import clsx from "clsx";
import { withEnabledComponent } from "../../../shared/lib/constructor/withEnabledComponent.js";
import "../../../shared/store/config/middleware/index.js";
import { selectBenefits } from "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import styles from "./Benefits.module.scss.js";
const Benefits = withEnabledComponent(
  memo(function Benefits2({ className, ...props }) {
    return /* @__PURE__ */ jsx(Benefits$1, { className: clsx(styles.benefits, className), ...props });
  }),
  selectBenefits
);
export {
  Benefits
};
